<template>
    <formulario :aspirante="aspirante" :lista_estudios="lista_estudios" :certificado_adjunto="certificado_adjunto" :curriculum_adjunto="curriculum_adjunto"></formulario>
</template>

<script>

import Formulario from './Formulario.vue'
import Layout from '@/Shared/Layout'

export default {
    metaInfo() {
        return {
            title: `${this.form.nombre} ${this.form.apellido}`,
        }
    },
    components: {
        Formulario
    },
    layout: Layout,
    props: {
        aspirante: Object,
        lista_estudios:Object,
        curriculum_adjunto:Object,
        certificado_adjunto:Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                nombre: this.aspirante.nombre,
                apellido: this.aspirante.apellido,
                tipo_documento_id: this.aspirante.tipo_documento_id,
                numero_documento: this.aspirante.numero_documento,
                cuit_cuil:this.aspirante.cuit_cuil,
                correo_electronico: this.aspirante.correo_electronico,
                fecha_de_nacimiento: this.aspirante.fecha_de_nacimiento,
                curriculum_adjunto:this.aspirante.curriculum_adjunto,

                certificado_de_discapacidad: this.aspirante.certificado_de_discapacidad,
                tipodiscapacidad: this.aspirante.tipodiscapacidad,
                adaptaciones_o_necesidades_requeridas: this.aspirante.adaptaciones_o_necesidades_requeridas,
                
                domicilioConstituido_calle : this.aspirante.domicilioConstituido_calle,
                domicilioConstituido_numero : this.aspirante.domicilioConstituido_numero,
                domicilioConstituido_piso : this.aspirante.domicilioConstituido_piso,
                domicilioConstituido_departamento : this.aspirante.domicilioConstituido_departamento,
                domicilioConstituido_codigo_postal : this.aspirante.domicilioConstituido_codigo_postal,
                domicilioConstituido_localidad : this.aspirante.domicilioConstituido_localidad,
                domicilioConstituido_telefono : this.aspirante.domicilioConstituido_telefono,
                codigo_area_telefono:this.aspirante.codigo_area_telefono,
            
                experiencia_judicial : this.aspirante.experiencia_judicial,
                detalle_exp_judicial : this.aspirante.detalle_exp_judicial,
                auxiliar : this.aspirante.auxiliar,
                auxiliar_de_servicio : this.aspirante.auxiliar_de_servicio,

                estudio_id : this.aspirante.estudio_id,
                universitario_descripcion : this.aspirante.universitario_descripcion,
                tipoestudio : this.aspirante.tipoestudio,

                intereses : this.aspirante.intereses,

                estudio:this.aspirante.estudio,
                tipo_documento:this.aspirante.tipo_documento
            }),
            options: [{
                value: 'true',
                label: 'SI'
            }, {
                value: 'false',
                label: 'NO'
            }],
            // lista_estudios: [{
            //     value: '2',
            //     label: 'ABOGACIA'
            // },
            // {
            //     value: '3',
            //     label: 'MARTILLERO PUBLICO'
            // }],
            lista_documento: [{
                value: '1',
                label: 'DNI'
            },
            {
                value: '2',
                label: 'PASAPORTE'
            }],
        }
    },
    mounted(){
    },
    methods: {
        // update() {
        //     this.form.put(this.route('aspirantes.update', this.aspirante.id))
        // },
    },
}
</script>
